<template>
  <div id="PropertyRentalData" class="p-4">
    <vx-card class="shadow-sm">
      <div class="p-2">
        
        <div class="flex items-center justify-between mb-6">
          <h4 class="flex items-center">
            <feather-icon icon="DollarSignIcon" class="mr-2 text-success" />
            {{ $t('RentalData') }}
          </h4>
          
          <div class="flex gap-2">
            <vs-button 
              color="primary" 
              icon-pack="feather" 
              icon="icon-save" 
              @click="submitRentalData"
              :disabled="!property.Id || property.Id <= 0"
            >
              {{ $t('SaveChanges') }}
            </vs-button>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-full mb-4">
            <label class="text-sm opacity-75">{{ $t('RentalAmount') }}</label>
            <vs-input 
              :disabled="!property.Id || property.Id <= 0"
              type="number" 
              v-model="rental.RentalAmount" 
              class="w-full mt-2" 
              placeholder="Monthly value" 
              icon-pack="feather" 
              icon="icon-credit-card"
            />
          </div>

          <div class="vx-col md:w-1/4 w-full mb-4">
            <label class="text-sm opacity-75">{{ $t('Frequency') }}</label>
            <vs-input 
              :disabled="!property.Id || property.Id <= 0"
              v-model="rental.RentalFrequency" 
              class="w-full mt-2" 
              placeholder="Monthly / Yearly" 
              icon-pack="feather" 
              icon="icon-repeat"
            />
          </div>

          <div class="vx-col md:w-1/4 w-full mb-4">
            <label class="text-sm opacity-75">{{ $t('OccupancyRate') }}</label>
            <vs-input 
              :disabled="!property.Id || property.Id <= 0"
              type="number" 
              v-model="rental.OccupancyRate" 
              class="w-full mt-2" 
              placeholder="95%" 
              icon-pack="feather" 
              icon="icon-percent"
            />
          </div>

          <div class="vx-col md:w-1/4 w-full mb-4">
            <label class="text-sm opacity-75">{{ $t('AnnualYield') }} %</label>
            <vs-input 
              :disabled="!property.Id || property.Id <= 0"
              type="number" 
              step="0.1" 
              v-model="rental.AnnualYieldPercent" 
              class="w-full mt-2" 
              placeholder="8.5%" 
              icon-pack="feather" 
              icon="icon-trending-up"
            />
          </div>
        </div>

        <div class="vx-row mt-4">
          <div class="vx-col md:w-1/4 w-full mb-4">
            <label class="text-sm opacity-75">{{ $t('ContractStart') }}</label>
            <datepicker 
              :disabled="!property.Id || property.Id <= 0"
              v-model="rental.ContractStartDate" 
              class="w-full mt-2" 
              placeholder="DD/MM/YYYY" 
              :append-to-body="true"
            />
          </div>

          <div class="vx-col md:w-1/4 w-full mb-4">
            <label class="text-sm opacity-75">{{ $t('ContractEnd') }}</label>
            <datepicker 
              :disabled="!property.Id || property.Id <= 0"
              v-model="rental.ContractEndDate" 
              class="w-full mt-2" 
              placeholder="DD/MM/YYYY" 
              :append-to-body="true"
            />
          </div>

          <div class="vx-col md:w-1/2 w-full mb-4">
            <label class="text-sm opacity-75">{{ $t('Notes') }}</label>
            <vs-input 
              :disabled="!property.Id || property.Id <= 0"
              v-model="rental.Notes" 
              class="w-full mt-2" 
              placeholder="Optional note" 
              icon-pack="feather" 
              icon="icon-edit-2"
            />
          </div>
        </div>

      </div>
    </vx-card>
  </div>
</template>

<script>

import Datepicker from 'vuejs-datepicker';
import moduleProperties from "@/store/Properties/moduleProperties.js";

export default {
  components: {
    Datepicker
  },
  props: {

    property: { type: Object, required: true }
  },
  data() {
    return {
  
      rental: {
        PropertyId: null,
        RentalAmount: '',
        RentalFrequency: '',
        ContractStartDate: null,
        ContractEndDate: null,
        OccupancyRate: '',
        AnnualYieldPercent: '',
        Notes: ''
      }
    };
  },
  computed: {
  rentalDataFromStore() {
    return this.$store.state.PropertiesList.propertyRentalData;
  }
},
watch: {
  property: {
    handler(newVal) {
      if (newVal && newVal.Id) {
        this.rental.PropertyId = newVal.Id;
      }
    },
    immediate: true,
    deep: true
  },
  

  rentalDataFromStore: {
    handler(newVal) {
      if (newVal && newVal.length > 0) {
        const data = newVal[0]; 
        this.rental = {
          Id: data.Id,
          PropertyId: data.PropertyId,
          RentalAmount: data.RentalAmount,
          RentalFrequency: data.RentalFrequency,
          ContractStartDate: data.ContractStartDate,
          ContractEndDate: data.ContractEndDate,
          OccupancyRate: data.OccupancyRate,
          AnnualYieldPercent: data.AnnualYieldPercent,
          Notes: data.Notes
        };
      }
    },
    deep: true
  }
},
 methods: {
  submitRentalData() {
    if (!this.rental.PropertyId) {
      this.$vs.notify({ title: 'Error', text: 'Property ID not found', color: 'danger' });
      return;
    }

    this.$vs.loading();

    const payload = {
      ...this.rental,

      ContractStartAt: this.rental.ContractStartAt ? new Date(this.rental.ContractStartAt).toISOString() : null,
      ContractEndAt: this.rental.ContractEndAt ? new Date(this.rental.ContractEndAt).toISOString() : null,
    };

    this.$store.dispatch('PropertiesList/updatePropertyRentalData', payload)
      .then(() => {
        this.$vs.loading.close();
        this.showSuccess();
      })
      .catch(err => {
        this.$vs.loading.close();
    
      });
  },
  showSuccess() {
    this.$vs.notify({
      title: this.$t('Success'),
      text: this.$t('RentalDataSavedSuccessfully'),
      color: 'success',
      iconPack: 'feather',
      icon: 'icon-check'
    });
  }
},
 created() {

  if (!moduleProperties.isRegistered) {
      this.$store.registerModule("PropertiesList", moduleProperties);
      moduleProperties.isRegistered = true;
    }
   

  if (this.property && this.property.Id) {
    this.rental.PropertyId = this.property.Id;
    this.$store.dispatch('PropertiesList/fetchPropertyRentalData', this.property.Id);
  }
},
};
</script>

<style lang="scss" scoped>
#PropertyRentalData {
::v-deep .vdp-datepicker__calendar {
  bottom: 100% !important; /* تفتح لفوق */
  top: auto !important;
  z-index: 99999 !important;
  background: white !important;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2) !important;
}
  .vdp-datepicker {
    input {
      padding: 0.7rem 1rem 0.7rem 3rem;
      border-radius: 5px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      width: 100%;
      height: 38px;
      
      &:focus {
        border-color: rgba(var(--vs-primary), 1);
        box-shadow: 0 3px 10px 0 rgba(var(--vs-primary), 0.15);
      }
    }
  }
}
</style>